import React, { memo, forwardRef } from "react";
const SvgAlphabetS = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.76 13.3a2.394 2.394 0 00-.8-.44 2.354 2.354 0 00-.82-.14c-.386 0-.74.08-1.06.24-.32.16-.48.427-.48.8 0 .373.174.633.52.78.36.147.88.3 1.56.46.36.08.72.187 1.08.32.373.133.707.313 1 .54.307.213.553.487.74.82.187.32.28.72.28 1.2 0 .587-.113 1.087-.34 1.5-.213.4-.507.727-.88.98-.36.253-.787.433-1.28.54a6.162 6.162 0 01-3.12-.04 4.008 4.008 0 01-1.4-.66c-.213-.16-.36-.32-.44-.48a1.345 1.345 0 01-.1-.48c0-.28.093-.52.28-.72a.94.94 0 01.72-.3c.133 0 .26.027.38.08.133.04.28.12.44.24.574.453 1.187.68 1.84.68.173 0 .353-.02.54-.06.187-.04.353-.1.5-.18.147-.093.267-.213.36-.36a.893.893 0 00.16-.54c0-.4-.187-.68-.56-.84-.373-.173-.926-.347-1.66-.52-.36-.08-.713-.18-1.06-.3a3.913 3.913 0 01-.9-.5 2.42 2.42 0 01-.64-.78c-.16-.32-.24-.707-.24-1.16 0-.533.107-.993.32-1.38.227-.387.52-.7.88-.94.36-.253.767-.44 1.22-.56.454-.12.92-.18 1.4-.18.48 0 .954.06 1.42.18.48.12.893.307 1.24.56.227.173.38.34.46.5.08.147.12.293.12.44 0 .267-.087.5-.26.7-.173.187-.413.28-.72.28-.227 0-.46-.093-.7-.28z"
      />
    </svg>
  );
});
SvgAlphabetS.displayName = "SvgAlphabetS";
const MemoForwardRef = memo(SvgAlphabetS);
export default MemoForwardRef;
